import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { UpdateBanner } from "@/features/pwa/update-banner";
import { I18nProvider } from "@/i18n";
import { ApiError } from "@/lib/api";
import { installNativeBack } from "@/lib/native-back";
import { installErrorReporting } from "@/lib/report-error";
import { installTheme } from "@/lib/theme";
import { createAppRouter } from "./router";
import "./styles.css";

installErrorReporting();
installTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, error) =>
        !(error instanceof ApiError && error.status >= 400 && error.status < 500) && count < 2,
      refetchOnWindowFocus: true,
    },
    // Mutations decide for themselves what to do without a connection (the POS saves offline).
    mutations: { retry: false, networkMode: "always" },
  },
});

const router = createAppRouter(queryClient);
// Harmless in a browser: only the Android app ever calls it.
installNativeBack(router);

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        <RouterProvider router={router} />
        <UpdateBanner />
      </I18nProvider>
    </QueryClientProvider>
  </StrictMode>,
);
